<script>
  import ListHeader from '../../../../components/list/Header.vue'

  import * as restfulService from '../../../../services/restfulService'

  import bus from '@utils/bus'

  import {orderBy} from 'lodash'

  export default {
    components: {ListHeader},
    data () {
      return {
        activeTab: 'premiacao-eventos',
        mainEventId: null,
        list: [],
        filters: {
          subevento: '',
          area_conhecimento: '',
          curso: '',
          instituicao: '',
          orientador: ''
        }
      }
    },
    computed: {
      pageTitle: function () {
        return 'Relatórios Finais'
      },
      listFiltered: function () {
        let list = this.list
        if (this.filters.subevento) {
          list = list.filter(item => item.subevento && item.subevento.includes(this.filters.subevento))
        }
        if (this.filters.area_conhecimento) {
          list = list.filter(item => item.area_conhecimento && item.area_conhecimento.includes(this.filters.area_conhecimento))
        }
        if (this.filters.curso) {
          list = list.filter(item => item.curso && item.curso.includes(this.filters.curso))
        }
        if (this.filters.instituicao) {
          list = list.filter(item => item.instituicao && item.instituicao.includes(this.filters.instituicao))
        }
        if (this.filters.orientador) {
          list = list.filter(item => item.orientador && item.orientador.includes(this.filters.orientador))
        }
        if (this.activeTab === 'premiacao-eventos') {
          return orderBy(list, ['subevento', 'area_conhecimento', 'media_geral'], ['asc', 'asc', 'desc'])
        }
        if (this.activeTab === 'merito-institucional') {
          return orderBy(list, ['total'], ['desc'])
        }
        return list
      },
      listSubeventos: function () {
        return [...new Set(this.list.filter(item => item.subevento).map(item => item.subevento))].sort()
      },
      listAreaConhecimento: function () {
        return [...new Set(this.list.filter(item => item.area_conhecimento).map(item => item.area_conhecimento))].sort()
      },
      listCursos: function () {
        return [...new Set(this.list.filter(item => item.curso).map(item => item.curso))].sort()
      },
      listInstituicoes: function () {
        return [...new Set(this.list.filter(item => item.instituicao).map(item => item.instituicao))].sort()
      },
      listOrientadores: function () {
        return [...new Set(this.list.filter(item => item.orientador).map(item => item.orientador))].sort()
      }
    },
    mounted () {
      this.mainEventId = this.$route.params.id || null
      this.loadList(this.activeTab)
    },
    watch: {
      activeTab: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadList(newValue)
        }
      }
    },
    methods: {
      loadList (route) {
        bus.$emit('show-loader')
        this.list.splice(0)
        restfulService.get('event', 'reports/' + route, this.mainEventId)
          .then(response => {
            this.list = [...response]
            bus.$emit('hide-loader')
          })
          .catch((err) => {
            console.log(err)
            bus.$emit('hide-loader')
          })
      },
      onFilterClean () {
        this.filters = {
          subevento: '',
          area_conhecimento: '',
          curso: '',
          instituicao: '',
          orientador: ''
        }
      }
    }
  }
</script>

<template>
    <div>
        <ListHeader :title="pageTitle" back-route="event.index"/>

        <el-card class="el-card__search_list box-card" style="margin-bottom: 30px;">
            <div slot="header">
                <span>Filtrar Listagem</span>
                <div>
                    <el-button type="default" @click="onFilterClean">Limpar todos filtros</el-button>
                </div>
            </div>
            <el-form :inline="true" :model="filters" class="demo-form-inline">
                <el-form-item label="Evento">
                    <el-select v-model="filters.subevento"
                               clearable
                               placeholder="Filtrar por Evento"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in listSubeventos"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Grande Área CNPQ">
                    <el-select v-model="filters.area_conhecimento"
                               clearable
                               placeholder="Filtrar por Grande Área CNPQ"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in listAreaConhecimento"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Curso">
                    <el-select v-model="filters.curso"
                               clearable
                               placeholder="Filtrar por Curso"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in listCursos"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Instituição">
                    <el-select v-model="filters.instituicao"
                               clearable
                               placeholder="Filtrar por Instituição"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in listInstituicoes"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Orientador">
                    <el-select v-model="filters.orientador"
                               clearable
                               placeholder="Filtrar por Orientador"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in listOrientadores"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </el-card>

        <el-tabs type="card" v-model="activeTab">
            <el-tab-pane name="premiacao-eventos" label="Relatório Premiação Eventos">
                <div class="responsive-table">
                    <table class="custom-table-list" v-if="activeTab === 'premiacao-eventos'">
                        <thead>
                        <tr>
                            <th colspan="12" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                        </tr>
                        <tr>
                            <th>Evento</th>
                            <th>Grande Área CNPQ</th>
                            <th>Curso</th>
                            <th>Instituição</th>
                            <th>Simpósio Temático</th>
                            <th>Código do Trabalho/Título</th>
                            <th>Autor/E-mail</th>
                            <th>Coautores</th>
                            <th>Orientador</th>
                            <th>Média WEB</th>
                            <th>Média InLOCO</th>
                            <th>Média Geral</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in listFiltered">
                            <td>{{item.subevento}}</td>
                            <td>{{item.area_conhecimento}}</td>
                            <td>{{item.curso}}</td>
                            <td>{{item.instituicao}}</td>
                            <td>{{item.simposio_tematico}}</td>
                            <td>{{item.cod_trabalho}} - {{item.titulo}}</td>
                            <td>{{item.autor}} ({{item.email}})</td>
                            <td>{{item.coautores}}</td>
                            <td>{{item.orientador}}</td>
                            <td>{{item.media_web}}</td>
                            <td>{{item.media_inloco}}</td>
                            <td>{{item.media_geral}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane name="merito-institucional" label="Relatório Mérito Institucional">
                <div class="responsive-table">
                    <table class="custom-table-list" v-if="activeTab === 'merito-institucional'">
                        <thead>
                        <tr>
                            <th colspan="12" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                        </tr>
                        <tr>
                            <th>Evento</th>
                            <th>Orientador</th>
                            <th>Total Trabalhos Orientados</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in listFiltered">
                            <td>{{item.subevento}}</td>
                            <td>{{item.orientador}}</td>
                            <td>{{item.total}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>



// WEBPACK FOOTER //
// ReportsFinals.vue?eb8ba53c